import { SvelteComponent, init, safe_not_equal, element, attr, insert, noop, detach } from '../../../../external_node_modules/svelte/internal/index.mjs.js';
import './Loader.css.js';

/* src/ui/shared/components/Loader/Loader.svelte generated by Svelte v3.44.2 */

function create_fragment(ctx) {
	let div1;

	return {
		c() {
			div1 = element("div");
			div1.innerHTML = `<div class="loader-ring wcl-wu0o2h"></div>`;
			attr(div1, "class", "loader wcl-wu0o2h");
		},
		m(target, anchor) {
			insert(target, div1, anchor);
		},
		p: noop,
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(div1);
		}
	};
}

class Loader extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, null, create_fragment, safe_not_equal, {});
	}
}

export { Loader as default };
//# sourceMappingURL=Loader.svelte.js.map
